import type { DriverCurrentRoutes, WorkspaceCurrentRoutesResponse } from "../web-client/api/data-contracts";
import * as operations from "../web-client/api/operations";
import type { Transport } from "../web-client/transport";

/** Query keys for the current-route reads, so a poll and a one-off read of the same thing share a cache entry. */
export const routeKeys = {
  membershipCurrent: (workspaceId: string, membershipId: string) =>
    ["routes", "current", workspaceId, membershipId] as const,
};

/**
 * One page of a walk over the workspace's drivers who are on a route, with the routes they are on.
 *
 * Without `cursor`, the first page of a full walk. With the `cursor` of a previous answer, the walk's next page when
 * that answer had `hasMore`, else the first page of the next walk, which the server decides is full or a delta; `full`
 * on the answer says which. `limit` caps the drivers on the page.
 */
export function getWorkspaceCurrentRoutes(
  transport: Transport,
  { workspaceId, cursor, limit }: { workspaceId: string; cursor?: string; limit: number },
): Promise<WorkspaceCurrentRoutesResponse> {
  return operations.getWorkspacesCurrentRoutes(transport, { workspaceId, cursor, limit });
}

/**
 * The routes one driver is on, in the same element shape as the workspace read; empty for a driver on nothing.
 */
export function getMembershipCurrentRoutes(
  transport: Transport,
  { workspaceId, membershipId }: { workspaceId: string; membershipId: string },
): Promise<DriverCurrentRoutes> {
  return operations.getWorkspacesMembershipsCurrentRoutes(transport, { workspaceId, membershipId });
}
